import React from 'react';
import { Box, alpha, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';

const CategoryLabel = ({ category, categoryHeight, index }) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const CustomComponent = category.component;

  return (
    <Box
      sx={{
        height: `${categoryHeight}px`,
        minHeight: `${categoryHeight}px`,
        borderBottom: `2px solid ${theme.palette.divider}`,
        display: 'flex',
        alignItems: 'flex-start',
        px: CustomComponent ? 0 : 2,
        py: CustomComponent ? 0 : 1,
        bgcolor: index % 2 === 0 ? 'white' : alpha(theme.palette.grey[50], 0.5),
        overflow: "hidden",
        pointerEvents: 'auto',
      }}
    >
      {CustomComponent ? (
        <CustomComponent
          category={category}
          height={categoryHeight}
          isEven={index % 2 === 0}
        />
      ) : (
        <Box sx={{ width: '100%' }}>
          <Typography variant="subtitle2" sx={{
            fontWeight: 600,
            color: 'grey.800',
            mb: -1
          }}>
            {category.name}
          </Typography>
          <Typography variant="caption" sx={{
            color: 'grey.600',
            display: 'block'
          }}>
            {t('common:gantt.task_count', { count: category.tasks.length })}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default CategoryLabel;
